import { Link } from "react-router-dom";
import { euro, nlNum, label } from "../lib/api";
import { Stars } from "./Reviews";

export const Avail = ({ a, testid }) => {
  const color = a?.state === "deliverable" ? "bg-[#2E7D32]" : a?.orderable ? "bg-[#D97706]" : "bg-[#9AA0A6]";
  return (
    <span data-testid={testid} className="inline-flex items-center gap-2 text-xs text-[#4A5056]">
      <span className={`w-2 h-2 rounded-full ${color}`} />{a?.label}
    </span>
  );
};

export const FloorTile = ({ name, small }) => (
  <div className="w-full h-full bg-[#EFE8E0] flex flex-col items-center justify-center text-center p-6 relative grain">
    <span className="font-serif-brand text-[#B78B7B] text-lg">VLOVER</span>
    {!small && <span className="text-[11px] text-[#6E747B] mt-2 max-w-[80%]">Productfoto volgt</span>}
  </div>
);

export default function ProductCard({ p, i = 0 }) {
  return (
    <Link to={`/product/${p.slug}`} data-testid={`product-card-${p.slug}`} className="group block fade-up bg-white rounded-2xl p-2.5 lift" style={{ animationDelay: `${Math.min(i, 12) * 40}ms` }}>
      <div className="aspect-[4/5] overflow-hidden rounded-xl bg-[#EFE8E0] relative">
        {p.image ? <img data-testid={`product-card-image-${p.slug}`} src={p.image.src} alt={p.image.alt} loading="lazy" className={`swap-img absolute inset-0 w-full h-full ${["pvc", "laminaat", "hout", "keramiek"].includes(p.group) ? "object-cover" : "object-contain p-3 bg-white"} group-hover:scale-[1.03]`} /> : <FloorTile name={p.name} />}
        {p.image2 && <img src={p.image2.src} alt="" loading="lazy" data-testid={`product-card-hover-image-${p.slug}`} className="swap-img absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100" />}
        {p.pattern && <span className="absolute top-3 left-3 bg-white/90 backdrop-blur text-[11px] px-3 py-1 rounded-full text-[#34393E]">{label[p.pattern] || p.pattern}</span>}
        {p.image?.test_display && <span className="absolute bottom-3 left-3 bg-white/90 text-[10px] px-2 py-1 rounded-full text-[#6E747B]">testweergave</span>}
        {p.is_test && <span className="absolute top-3 right-3 bg-[#D97706] text-white text-[10px] px-2 py-1 rounded-full">TESTPRODUCT</span>}
      </div>
      <div className="px-2 pt-4 pb-2 space-y-1.5">
        <p className="eyebrow !text-[0.62rem]">{p.brand}{p.floor_type ? ` · ${label[p.floor_type] || p.floor_type}` : ""}</p>
        <h3 className="text-[15px] leading-snug text-[#272D30] group-hover:text-[#B78B7B] transition-colors line-clamp-2">{p.name}</h3>
        {p.vlover_code && <p className="text-xs text-[#595F66]" data-testid={`product-code-${p.slug}`}>VLOVER {p.vlover_code}</p>}
        {p.application && <p className="text-xs text-[#6E747B] line-clamp-2" data-testid={`product-application-${p.slug}`}>{p.application}</p>}
        {p.variant && <p className="text-xs text-[#8A6A5E]" data-testid={`product-variant-${p.slug}`}>{p.variant}</p>}
        <div className="flex items-baseline gap-2 flex-wrap">
          {p.price_m2_cents ? <><span className="font-semibold text-[17px]">{euro(p.price_m2_cents)}<span className="text-xs font-normal text-[#6E747B]"> /m²</span></span>
          <span className="text-xs text-[#6E747B]">{euro(p.price_cents)} {p.unit_label || "per pak"}</span></>
            : <span className="font-semibold text-[17px]">{euro(p.price_cents)}<span className="text-xs font-normal text-[#6E747B]"> {(p.unit_label || "per stuk").replace(/^.*?(per )/, "$1")}</span></span>}
        </div>
        <Avail a={p.availability} />
        {p.rating && <span className="flex items-center gap-1.5 text-xs text-[#6E747B]" data-testid={`product-card-rating-${p.slug}`}><Stars value={p.rating.avg} size={12} />{p.rating.count}</span>}
      </div>
    </Link>
  );
}
